// extracted by mini-css-extract-plugin
export var actionButton = "_ok-0";
export var actionMenuContainer = "_ok-i";
export var bubble = "_ok-2";
export var bubbleActionMenu = "_ok-j";
export var bubbleContext = "_ok-6";
export var bubbleItems = "_ok-7";
export var customer = "_ok-3";
export var divider = "_ok-8";
export var fileList = "_ok-9";
export var hiddenComment = "_ok-o";
export var infoAbove = "_ok-a";
export var internal = "_ok-4";
export var lightActionButton = "_ok-1";
export var link = "_ok-b";
export var merchant = "_ok-5";
export var message = "_ok-c";
export var profilePicture = "_ok-e";
export var quillToolbarContainer = "_ok-f";
export var senderDate = "_ok-g";
export var senderDateCustomer = "_ok-h";
export var senderName = "_ok-d";
export var time = "_ok-k";
export var uploadedImage = "_ok-l";
export var username = "_ok-m";
export var xsmall = "_ok-n";